
// 西药房房 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

// 添加供应商
export const addSupplierEntity = (data) => {
    return request.post("/outpatient/addSupplierEntity", data)
}


// 修改供应商
export const editSupplierEntity = (data) => {
    return request.post("/outpatient/updateSupplierEntityStatus", data)
}
/**
 * 
 * get 
 *  
 */

// 供应商列表
export const selectSupplierEntityList = (params) => {
    return request.get("/outpatient/selectSupplierEntityList", { params })
}

// 供应商列表获取详情
export const SupplierDetails = (params) => {
    return request.get("/outpatient/getDetails", { params })
}



/**
 * 
 * DELETE 
 *  
 */
// 删除
// export const deleteDoc = (params) => {
//     return request.delete("/outpatient/dugDoc/deleteDoc", { params })
// }


/*
	Others
*/

// 禁用或者启用供应商
export const updateSupplierEntity = (params) => {
    return request.get("/outpatient/updateSupplierEntity", { params })
}

// 暴露
export default{
	// 供应商列表
	selectSupplierEntityList,SupplierDetails,
	// 添加供应商
	addSupplierEntity,editSupplierEntity,
	// 禁用等
	updateSupplierEntity,
}